import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "formly-segmented-control",
  imports: [ReactiveFormsModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="mb-3">
      @if (props.label) {
        <h5 class="font-alternate text-sm font-semibold text-black tracking-tight mb-1.5">
          {{ props.label | translate }}
        </h5>
      }
      <div class="segmented-track" role="group">
        @for (segment of segments; track segment.value) {
          <button
            type="button"
            class="segmented-btn"
            [class.active]="formControl.value === segment.value"
            (click)="onSelect(segment.value)"
          >
            {{ segment.label | translate }}
          </button>
        }
        <span
          class="segmented-indicator"
          [style.width.%]="100 / segments.length"
          [style.left.%]="activeIndex * (100 / segments.length)"
        ></span>
      </div>
    </div>
  `,
  styles: [`
    .segmented-track {
      position: relative;
      display: flex;
      background: #edeef0;
      border-radius: 6px;
      padding: 2px;
    }

    .segmented-indicator {
      position: absolute;
      top: 2px;
      bottom: 2px;
      border-radius: 5px;
      background: #fff;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
      transition: left 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      pointer-events: none;
      z-index: 0;
    }

    .segmented-btn {
      position: relative;
      z-index: 1;
      flex: 1;
      padding: 5px 10px;
      border: none;
      border-radius: 5px;
      background: transparent;
      color: #6b7280;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      transition: color 0.2s ease;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
      outline: none;
    }

    .segmented-btn:hover:not(.active) {
      color: #374151;
    }

    .segmented-btn.active {
      color: #111827;
    }
  `],
})
export class SegmentedControlFieldType extends FieldType<FieldTypeConfig> {
  get segments(): { value: string; label: string }[] {
    return this.props["segments"] || [];
  }

  get activeIndex(): number {
    const idx = this.segments.findIndex((s) => s.value === this.formControl.value);
    return idx >= 0 ? idx : 0;
  }

  onSelect(value: string): void {
    this.formControl.setValue(value);
  }
}
